import { render, staticRenderFns } from "./MediaAvatar.vue?vue&type=template&id=562cd076&scoped=true&"
import script from "./MediaAvatar.vue?vue&type=script&lang=js&"
export * from "./MediaAvatar.vue?vue&type=script&lang=js&"
import style0 from "./MediaAvatar.vue?vue&type=style&index=0&id=562cd076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562cd076",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VIcon})
